import { render, staticRenderFns } from "./MantenedorTipoUbicacionPantalla.vue?vue&type=template&id=37a3fad0&"
import script from "./MantenedorTipoUbicacionPantalla.vue?vue&type=script&lang=ts&"
export * from "./MantenedorTipoUbicacionPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports